import { useContext } from 'react';
import { TableContext } from 'templates/context/TableContext';

export function useDataTable() {
  const context = useContext(TableContext);
  return context;
}
